import React, { Component } from 'react'

class Filters extends Component {

  constructor(props) {
    super(props)
  }

  render (){
    return(
      <section><a className="anchor" id="filters"></a>
        <h2>Filters</h2>

        <h3>Core Layout</h3>

        <p>The Default wording for filters will be:</p>

        <ul>
          <li><b>Title:</b> "Filters" or "Refine By:"</li>
          <li><b>Button:</b> "Apply" or "Submit"</li>
        </ul>

        <p>You can add an <code>is-title</code> CSS class to the filter div to make use of this layout.</p>

        <div className="iframe-container display--flex" style={{
          "height":"700px",
          "border": "0",
          "flexDirection": "column"
        }}>
          <iframe seamless srcDoc={`
            <html class="height--100" style="background-color: #dedfe0">
              <head>
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
                <link rel="stylesheet" type="text/css" href="css/commonUI.css">
              </head>
                <body class="height--100">
                  <div class="filter js-filter-panel is-title" id="filter-ex-a">
                    <div class="filter__wrapper">
                      <div class="filter__sidebar js-filter-panel__open" id="filter-ex-a-sidebar">
                        <div class="filter__sidebar--heading">
                          <div class="filter__sidebar--heading--icon">
                            <i class="icon-cme-filter"></i>
                          </div>
                          <h3 class="flush--bottom filter__sidebar--heading--title push-quarter--left">Filters</h3>
                          <button class="btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard" id="filter-ex-a-sidebar-hide">
                            <span class="filter__sidebar--heading--hide--icon">
                              <i class="fa fa-chevron-left"></i> Hide
                            </span>
                            <span class="filter__sidebar--heading--hide--close">
                              <i class="icon-cme-close-circle-o"></i>
                            </span>
                          </button>
                        </div>

                        <div class="filter__sidebar--content" id="filter-ex-a-sidebar-content"></div>

                        <div class="filter__sidebar--open">
                          <i class="fa fa-chevron-right"></i>
                        </div>

                        <div class="filter__sidebar--seperator"></div>

                        <div class="filter__sidebar--action soft-half">
                          <button class="btn js-filter-panel__action width--100" id="filter-ex-a-sidebar-action">Apply</button>
                        </div>
                      </div>
                      <div class="filter__content" id="filter-ex-a-content">
                        <div class="well well--border-color push">
                          <h3 class="flush">Results Content</h3>
                          <button class="btn filter__content--action js-filter-panel__remote-open push--top" id="filter-ex-a-content-action">
                              <i class="filter__content--state js-filter-panel__state fa icon-cme-filter"></i>
                              <span class="push-quarter--left">Filters</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <script type="text/javascript" src="js/commonUI.js"></script>
                  <script>
                    function init() {
                      commonUI.initializeFilter();
                    }
                    window.onload = init;
                  </script>
                </body>
              </html>
            `}>
          </iframe>
        </div>

        <br/>

        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button>

        <br/><br/>

        <pre className="hide-code"><code className="language-html">{`<div class="filter js-filter-panel is-title">
  <div class="filter__wrapper">
    <div class="filter__sidebar js-filter-panel__open">
      <div class="filter__sidebar--heading">
        <div class="filter__sidebar--heading--icon">
          <i class="icon-cme-filter"></i>
        </div>
        <h3 class="flush--bottom filter__sidebar--heading--title push-quarter--left">Filters</h3>
        <button class="btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard">
          <span class="filter__sidebar--heading--hide--icon">
            <i class="fa fa-chevron-left"></i> Hide
          </span>
          <span class="filter__sidebar--heading--hide--close">
            <i class="icon-cme-close-circle-o"></i>
          </span>
        </button>
      </div>

      <div class="filter__sidebar--content"></div>

      <div class="filter__sidebar--open">
        <i class="fa fa-chevron-right"></i>
      </div>

      <div class="filter__sidebar--seperator"></div>

      <div class="filter__sidebar--action soft-half">
        <button class="btn js-filter-panel__action width--100">Apply</button>
      </div>
    </div>
    <div class="filter__content">
      <div class="well well--border-color push">
        <h3 class="flush">Results Content</h3>
        <button class="btn filter__content--action js-filter-panel__remote-open push--top">
            <i class="filter__content--state js-filter-panel__state fa icon-cme-filter"></i>
            <span class="push-quarter--left">Filters</span>
        </button>
      </div>
    </div>
  </div>
</div>`}</code></pre>

        <br/>

        <p>The sidebar remains a fixed width default 224px. (a small & large class will be available), is left aligned and scrolls independently
        and leaving the user in their place on the table/main content. Allow a gap of approximately 18px between the filter and the main content.</p>

        <p>If you wish for the sidebar to remain open, omit the <code>.js-filter-panel__action</code> CSS class from the sidebar action button.</p>

        <h3>With Icon</h3>

        <p>You can add an <code>is-icon</code> CSS class to the filter div to make use of this layout.</p>

        <div className="iframe-container display--flex" style={{
          "height":"700px",
          "border": "0",
          "flexDirection": "column"
        }}>
          <iframe seamless srcDoc={`
            <html class="height--100" style="background-color: #dedfe0">
              <head>
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
                <link rel="stylesheet" type="text/css" href="css/commonUI.css">
              </head>
                <body class="height--100">
                  <div class="filter js-filter-panel is-icon" id="filter-ex-b">
                    <div class="filter__wrapper">
                      <div class="filter__sidebar js-filter-panel__open" id="filter-ex-b-sidebar">
                        <div class="filter__sidebar--heading">
                          <div class="filter__sidebar--heading--icon">
                            <i class="icon-cme-filter"></i>
                          </div>
                          <button class="btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard" id="filter-ex-b-sidebar-hide">
                            <span class="filter__sidebar--heading--hide--icon">
                              <i class="fa fa-chevron-left"></i> Hide
                            </span>
                            <span class="filter__sidebar--heading--hide--close">
                              <i class="icon-cme-close-circle-o"></i>
                            </span>
                          </button>
                        </div>

                        <div class="filter__sidebar--content" id="filter-ex-b-sidebar-content"></div>

                        <div class="filter__sidebar--open">
                          <i class="fa fa-chevron-right"></i>
                        </div>

                        <div class="filter__sidebar--seperator"></div>

                        <div class="filter__sidebar--action soft-half">
                          <button class="btn js-filter-panel__action width--100" id="filter-ex-b-sidebar-action">Apply</button>
                        </div>
                      </div>
                      <div class="filter__content" id="filter-ex-b-content">
                        <div class="well well--border-color push">
                          <h3 class="flush">Results Content</h3>
                          <button class="btn filter__content--action js-filter-panel__remote-open push--top" id="filter-ex-b-content-action">
                              <i class="filter__content--state js-filter-panel__state fa icon-cme-filter"></i>
                              <span class="push-quarter--left">Filters</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <script type="text/javascript" src="js/commonUI.js"></script>
                  <script>
                    function init() {
                      commonUI.initializeFilter();
                    }
                    window.onload = init;
                  </script>
                </body>
              </html>
            `}>
          </iframe>
        </div>

        <br/>

        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button>

        <br/><br/>

        <pre className="hide-code"><code className="language-html">{`<div class="filter js-filter-panel is-icon">
  <div class="filter__wrapper">
    <div class="filter__sidebar js-filter-panel__open">
      <div class="filter__sidebar--heading">
        <div class="filter__sidebar--heading--icon">
          <i class="icon-cme-filter"></i>
        </div>
        <button class="btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard">
          <span class="filter__sidebar--heading--hide--icon">
            <i class="fa fa-chevron-left"></i> Hide
          </span>
          <span class="filter__sidebar--heading--hide--close">
            <i class="icon-cme-close-circle-o"></i>
          </span>
        </button>
      </div>

      <div class="filter__sidebar--content"></div>

      <div class="filter__sidebar--open">
        <i class="fa fa-chevron-right"></i>
      </div>

      <div class="filter__sidebar--seperator"></div>

      <div class="filter__sidebar--action soft-half">
        <button class="btn js-filter-panel__action width--100">Apply</button>
      </div>
    </div>
    <div class="filter__content">
      <div class="well well--border-color push">
        <h3 class="flush">Results Content</h3>
        <button class="btn filter__content--action js-filter-panel__remote-open push--top">
            <i class="filter__content--state js-filter-panel__state fa icon-cme-filter"></i>
            <span class="push-quarter--left">Filters</span>
        </button>
      </div>
    </div>
  </div>
</div>`}</code></pre>

        <br/>

        <br/><hr/><br/>

        <h3>With Text &amp; Icon</h3>

        <p>You can add an <code>is-icon-title</code> CSS class to the filter div to make use of this layout.</p>

        <div className="iframe-container display--flex" style={{
          "height":"700px",
          "border": "0",
          "flexDirection": "column"
        }}>
          <iframe seamless srcDoc={`
            <html class="height--100" style="background-color: #dedfe0">
              <head>
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
                <link rel="stylesheet" type="text/css" href="css/commonUI.css">
              </head>
                <body class="height--100">
                  <div class="filter js-filter-panel is-icon-title" id="filter-ex-c">
                    <div class="filter__wrapper">
                      <div class="filter__sidebar js-filter-panel__open" id="filter-ex-c-sidebar">
                        <div class="filter__sidebar--heading">
                          <div class="filter__sidebar--heading--icon">
                            <i class="icon-cme-filter"></i>
                          </div>
                          <h3 class="flush--bottom filter__sidebar--heading--title push-quarter--left">Filters</h3>
                          <button class="btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard" id="filter-ex-c-sidebar-hide">
                            <span class="filter__sidebar--heading--hide--icon">
                              <i class="fa fa-chevron-left"></i> Hide
                            </span>
                            <span class="filter__sidebar--heading--hide--close">
                              <i class="icon-cme-close-circle-o"></i>
                            </span>
                          </button>
                        </div>

                        <div class="filter__sidebar--content" id="filter-ex-c-sidebar-content"></div>

                        <div class="filter__sidebar--open">
                          <i class="fa fa-chevron-right"></i>
                        </div>

                        <div class="filter__sidebar--seperator"></div>

                        <div class="filter__sidebar--action soft-half">
                          <button class="btn js-filter-panel__action width--100" id="filter-ex-c-sidebar-action">Apply</button>
                        </div>
                      </div>
                      <div class="filter__content" id="filter-ex-c-content">
                        <div class="well well--border-color push">
                          <h3 class="flush">Results Content</h3>
                          <button class="btn filter__content--action js-filter-panel__remote-open push--top" id="filter-ex-c-content-action">
                              <i class="filter__content--state js-filter-panel__state fa icon-cme-filter"></i>
                              <span class="push-quarter--left">Filters</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <script type="text/javascript" src="js/commonUI.js"></script>
                  <script>
                    function init() {
                      commonUI.initializeFilter();
                    }
                    window.onload = init;
                  </script>
                </body>
              </html>
            `}>
          </iframe>
        </div>

        <br/>

        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button>

        <br/><br/>

        <pre className="hide-code"><code className="language-html">{`<div class="filter js-filter-panel is-icon-title">
  <div class="filter__wrapper">
    <div class="filter__sidebar js-filter-panel__open">
      <div class="filter__sidebar--heading">
        <div class="filter__sidebar--heading--icon">
          <i class="icon-cme-filter"></i>
        </div>
        <h3 class="flush--bottom filter__sidebar--heading--title push-quarter--left">Filters</h3>
        <button class="btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard">
          <span class="filter__sidebar--heading--hide--icon">
            <i class="fa fa-chevron-left"></i> Hide
          </span>
          <span class="filter__sidebar--heading--hide--close">
            <i class="icon-cme-close-circle-o"></i>
          </span>
        </button>
      </div>

      <div class="filter__sidebar--content"></div>

      <div class="filter__sidebar--open">
        <i class="fa fa-chevron-right"></i>
      </div>

      <div class="filter__sidebar--seperator"></div>

      <div class="filter__sidebar--action soft-half">
        <button class="btn js-filter-panel__action width--100">Apply</button>
      </div>
    </div>
    <div class="filter__content">
      <div class="well well--border-color push">
        <h3 class="flush">Results Content</h3>
        <button class="btn filter__content--action js-filter-panel__remote-open push--top">
            <i class="filter__content--state js-filter-panel__state fa icon-cme-filter"></i>
            <span class="push-quarter--left">Filters</span>
        </button>
      </div>
    </div>
  </div>
</div>`}</code></pre>

        <br/>

        <br/><hr/><br/>

        <h3>With Content</h3>

        <p>You can make use of other Common UI components within the filter's <code>filter__sidebar--content--wrapper</code> DOM element.</p>

        <div className="iframe-container display--flex" style={{
          "height":"700px",
          "border": "0",
          "flexDirection": "column"
        }}>
          <iframe seamless srcDoc={`
            <html class="height--100" style="background-color: #dedfe0">
              <head>
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
                <link rel="stylesheet" type="text/css" href="css/commonUI.css">
              </head>
                <body class="height--100">
                  <div class="filter js-filter-panel is-icon" id="filter-ex-d">
                    <div class="filter__wrapper">
                      <div class="filter__sidebar js-filter-panel__open" id="filter-ex-d-sidebar">
                        <div class="filter__sidebar--heading">
                          <div class="filter__sidebar--heading--icon">
                            <i class="icon-cme-filter"></i>
                          </div>
                          <button class="btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard" id="filter-ex-d-sidebar-hide">
                            <span class="filter__sidebar--heading--hide--icon">
                              <i class="fa fa-chevron-left"></i> Hide
                            </span>
                            <span class="filter__sidebar--heading--hide--close">
                              <i class="icon-cme-close-circle-o"></i>
                            </span>
                          </button>
                        </div>
                        <div class="filter__sidebar--content" id="filter-ex-d-sidebar-content">
                          <div class="filter__sidebar--content--wrapper">
                            <form class="js-filter-content-form">
                              <ul class="form-fields">
                                <li class="push-half--bottom">
                                  <label for="filtersFirstName">First Name</label>
                                  <input id="filtersFirstName" type="text" class="text-input width--100"/>
                                </li>
                                <li class="push-half--bottom">
                                  <label for="filtersSecondName">Second Name</label>
                                  <input id="filtersSecondName" type="text" class="text-input width--100"/>
                                </li>
                                <li class="push-half--bottom">
                                  <label for="filtersAge">Age</label>
                                  <input id="filtersAge" type="text" class="text-input width--100"/>
                                </li>
                                <li class="push-half--bottom">
                                  <label>How would you like to be contacted?</label>
                                  <ul class="check-list">
                                    <li>
                                        <input type="checkbox" id="filters-by-email"/> <label for="filters-by-email">By email</label>
                                    </li>
                                    <li>
                                        <input type="checkbox" id="filters-by-post"/> <label for="filters-by-post">By post</label>
                                    </li>
                                    <li>
                                        <input type="checkbox" id="filters-by-pigeon"/> <label for="filters-by-pigeon">By carrier pigeon</label>
                                    </li>
                                  </ul>
                                </li>
                                <li class="push-half--bottom">
                                  <label>Select your hero</label>
                                  <ul class="check-list">
                                    <li>
                                      <input type="radio" name="filters-hero" id="FiltersHector" /> <label for="FiltersHector">Hector</label>
                                    </li>
                                    <li>
                                      <input type="radio" name="filters-hero" id="FiltersAchilles" /> <label for="FiltersAchilles">Achilles</label>
                                    </li>
                                    <li>
                                      <input type="radio" name="filters-hero" id="FiltersAgamemnon" /> <label for="FiltersAgamemnon">Agamemnon</label>
                                    </li>
                                  </ul>
                                </li>
                                <li class="push-half--bottom">
                                  <label for="filters-countries">Select your country</label>
                                  <select id="filters-countries" name="filters-countries" class="width--100">
                                    <option>Argentina</option>
                                    <option>Albania</option>
                                    <option selected="selected">Aruba</option>
                                  </select>
                                </li>
                                <li class="push-half--bottom">
                                  <label>What is your feedback?</label>
                                  <textarea class="text-input width--100" name="comments" >Please enter your comments...</textarea>
                                </li>
                                <li class="push-half--bottom">
                                  <label>How would you like to be contacted?</label>
                                  <ul class="check-list">
                                    <li>
                                      <input type="checkbox" id="by-email"/> <label for="by-email">By email</label>
                                    </li>
                                    <li>
                                      <input type="checkbox" id="by-post"/> <label for="by-post">By post</label>
                                    </li>
                                    <li>
                                      <input type="checkbox" id="by-pigeon"/> <label for="by-pigeon">By carrier pigeon</label>
                                    </li>
                                  </ul>
                                </li>
                                <li class="push-half--bottom">
                                  <label for="countries">Select your country</label>
                                  <select id="countries" name="countries" class="width--100">
                                    <option>Argentina</option>
                                    <option>Albania</option>
                                    <option selected="selected">Aruba</option>
                                  </select>
                                </li>
                              </ul>
                            </form>
                          </div>
                        </div>
                        <div class="filter__sidebar--open">
                          <i class="fa fa-chevron-right"></i>
                        </div>

                        <div class="filter__sidebar--seperator"></div>

                        <div class="filter__sidebar--action soft-half">
                          <button class="btn js-filter-panel__action width--100" id="filter-ex-d-sidebar-action" disabled>Apply</button>
                        </div>
                      </div>
                      <div class="filter__content" id="filter-ex-d-content">
                        <div class="well well--border-color push">
                          <h3 class="flush">Results Content</h3>
                          <button class="btn filter__content--action js-filter-panel__remote-open push--top" id="filter-ex-d-content-action">
                              <i class="filter__content--state js-filter-panel__state fa icon-cme-filter"></i>
                              <span class="push-quarter--left">Filters</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <script type="text/javascript" src="js/commonUI.js"></script>
                  <script>
                    function init() {
                      commonUI.initializeFilter();
                      var filter = document.querySelector('.js-filter-panel');
                      filter.addEventListener('apply.commonui.filter', function (event) {}, false);
                    }
                    window.onload = init;
                  </script>
                </body>
              </html>
            `}>
          </iframe>
        </div>

        <br/>

        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button>

        <br/><br/>

        <pre className="hide-code"><code className="language-html">{`<div class="filter js-filter-panel is-icon">
  <div class="filter__wrapper">
    <div class="filter__sidebar js-filter-panel__open">
      <div class="filter__sidebar--heading">
        <div class="filter__sidebar--heading--icon">
          <i class="icon-cme-filter"></i>
        </div>
        <button class="btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard">
          <span class="filter__sidebar--heading--hide--icon">
            <i class="fa fa-chevron-left"></i> Hide
          </span>
          <span class="filter__sidebar--heading--hide--close">
            <i class="icon-cme-close-circle-o"></i>
          </span>
        </button>
      </div>
      <div class="filter__sidebar--content">
        <div class="filter__sidebar--content--wrapper">
          <form>
            <ul class="form-fields">
              <li class="push-half--bottom">
                <label for="filtersFirstName">First Name</label>
                <input id="filtersFirstName" type="text" class="text-input width--100"/>
              </li>
              <li class="push-half--bottom">
                <label for="filtersSecondName">Second Name</label>
                <input id="filtersSecondName" type="text" class="text-input width--100"/>
              </li>
              <li class="push-half--bottom">
                <label for="filtersAge">Age</label>
                <input id="filtersAge" type="text" class="text-input width--100"/>
              </li>
              <li class="push-half--bottom">
                <label>How would you like to be contacted?</label>
                <ul class="check-list">
                  <li>
                      <input type="checkbox" id="filters-by-email"/> <label for="filters-by-email">By email</label>
                  </li>
                  <li>
                      <input type="checkbox" id="filters-by-post"/> <label for="filters-by-post">By post</label>
                  </li>
                  <li>
                      <input type="checkbox" id="filters-by-pigeon"/> <label for="filters-by-pigeon">By carrier pigeon</label>
                  </li>
                </ul>
              </li>
              <li class="push-half--bottom">
                <label>Select your hero</label>
                <ul class="check-list">
                  <li>
                    <input type="radio" name="filters-hero" id="FiltersHector" /> <label for="FiltersHector">Hector</label>
                  </li>
                  <li>
                    <input type="radio" name="filters-hero" id="FiltersAchilles" /> <label for="FiltersAchilles">Achilles</label>
                  </li>
                  <li>
                    <input type="radio" name="filters-hero" id="FiltersAgamemnon" /> <label for="FiltersAgamemnon">Agamemnon</label>
                  </li>
                </ul>
              </li>
              <li class="push-half--bottom">
                <label for="filters-countries">Select your country</label>
                <select id="filters-countries" name="filters-countries" class="width--100">
                  <option>Argentina</option>
                  <option>Albania</option>
                  <option selected="selected">Aruba</option>
                </select>
              </li>
              <li class="push-half--bottom">
                <label>What is your feedback?</label>
                <textarea class="text-input width--100" name="comments" >Please enter your comments...</textarea>
              </li>
              <li class="push-half--bottom">
                <label>How would you like to be contacted?</label>
                <ul class="check-list">
                  <li>
                    <input type="checkbox" id="by-email"/> <label for="by-email">By email</label>
                  </li>
                  <li>
                    <input type="checkbox" id="by-post"/> <label for="by-post">By post</label>
                  </li>
                  <li>
                    <input type="checkbox" id="by-pigeon"/> <label for="by-pigeon">By carrier pigeon</label>
                  </li>
                </ul>
              </li>
              <li class="push-half--bottom">
                <label for="countries">Select your country</label>
                <select id="countries" name="countries" class="width--100">
                  <option>Argentina</option>
                  <option>Albania</option>
                  <option selected="selected">Aruba</option>
                </select>
              </li>
            </ul>
          </form>
        </div>
      </div>
      <div class="filter__sidebar--open">
        <i class="fa fa-chevron-right"></i>
      </div>

      <div class="filter__sidebar--seperator"></div>

      <div class="filter__sidebar--action soft-half">
        <button class="btn js-filter-panel__action width--100" disabled>Apply</button>
      </div>
    </div>
    <div class="filter__content">
      <div class="well well--border-color push">
        <h3 class="flush">Results Content</h3>
        <button class="btn filter__content--action js-filter-panel__remote-open push--top">
            <i class="filter__content--state js-filter-panel__state fa icon-cme-filter"></i>
            <span class="push-quarter--left">Filters</span>
        </button>
      </div>
    </div>
  </div>
</div>`}</code></pre>

        <br/>

        <p>There is a JavaScript event triggered on the component whenever the apply button is clicked. You can listen to this event like so:</p>

        <pre><code className="language-javascript">{`filterElement.addEventListener('cui-filters-apply', function (event) {}, false);`}</code></pre>

        <br/>

        <p>When a filter form is present in the sidebar, the apply button becomes disabled until the form is interacted with. There are two events to handle this
        functionality:</p>

        <pre>
          <code className="language-javascript">{`var filter = commonUI.initializeFilter();
filter.enableAction();
filter.disableAction();`}
          </code>
        </pre>

        <br/><hr/><br/>

        <h3>Embedded Filter</h3>

        <p>If you have multiple components on your page, you can wrap these in a <code>.filter__group</code> element. This will ensure that the filter
        properly spans the height of the browser window.</p>

        <div className="iframe-container display--flex" style={{
          "height":"700px",
          "border": "0",
          "flexDirection": "column"
        }}>
          <iframe seamless srcDoc={`
            <html class="height--100" style="background-color: #dedfe0">
              <head>
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
                <link rel="stylesheet" type="text/css" href="css/commonUI.css">
              </head>
                <body class="height--100">
                  <div class="filter__group">
                    <nav class="nav nav--global nav--light drop-shadow js-nav">
                      <div class="nav__inner">
                        <div class="nav__header nav__header--logo-only">
                          <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
                        </div>
                        <ul class="nav__items--primary">
                          <li class="nav__item--primary"><a>Trading</a></li>
                          <li class="nav__item--primary"><a>Clearing</a></li>
                          <li class="nav__item--primary"><a>Regulation</a></li>
                          <li class="nav__item--primary"><a>Data</a></li>
                          <li class="nav__item--primary"><a>Education</a></li>
                          <li class="nav__item--primary"><a>About</a></li>
                        </ul>
                        <ul class="nav__actions">
                          <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-star-o nav__action-icon"></i></button></li>
                          <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-search nav__action-icon"></i></button></li>
                          <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-profile nav__action-icon"></i></button></li>
                        </ul>
                      </div>
                    </nav>
                    <div class="filter js-filter-panel is-icon" id="filter-ex-d">
                      <div class="filter__wrapper">
                        <div class="filter__sidebar js-filter-panel__open" id="filter-ex-d-sidebar">
                          <div class="filter__sidebar--heading">
                            <div class="filter__sidebar--heading--icon">
                              <i class="icon-cme-filter"></i>
                            </div>
                            <button class="btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard" id="filter-ex-d-sidebar-hide">
                              <span class="filter__sidebar--heading--hide--icon">
                                <i class="fa fa-chevron-left"></i> Hide
                              </span>
                              <span class="filter__sidebar--heading--hide--close">
                                <i class="icon-cme-close-circle-o"></i>
                              </span>
                            </button>
                          </div>
                          <div class="filter__sidebar--content" id="filter-ex-d-sidebar-content">
                            <div class="filter__sidebar--content--wrapper">
                              <form class="js-filter-content-form">
                                <ul class="form-fields">
                                  <li class="push-half--bottom">
                                    <label for="filtersFirstName">First Name</label>
                                    <input id="filtersFirstName" type="text" class="text-input width--100"/>
                                  </li>
                                  <li class="push-half--bottom">
                                    <label for="filtersSecondName">Second Name</label>
                                    <input id="filtersSecondName" type="text" class="text-input width--100"/>
                                  </li>
                                  <li class="push-half--bottom">
                                    <label for="filtersAge">Age</label>
                                    <input id="filtersAge" type="text" class="text-input width--100"/>
                                  </li>
                                  <li class="push-half--bottom">
                                    <label>How would you like to be contacted?</label>
                                    <ul class="check-list">
                                      <li>
                                          <input type="checkbox" id="filters-by-email"/> <label for="filters-by-email">By email</label>
                                      </li>
                                      <li>
                                          <input type="checkbox" id="filters-by-post"/> <label for="filters-by-post">By post</label>
                                      </li>
                                      <li>
                                          <input type="checkbox" id="filters-by-pigeon"/> <label for="filters-by-pigeon">By carrier pigeon</label>
                                      </li>
                                    </ul>
                                  </li>
                                  <li class="push-half--bottom">
                                    <label>Select your hero</label>
                                    <ul class="check-list">
                                      <li>
                                        <input type="radio" name="filters-hero" id="FiltersHector" /> <label for="FiltersHector">Hector</label>
                                      </li>
                                      <li>
                                        <input type="radio" name="filters-hero" id="FiltersAchilles" /> <label for="FiltersAchilles">Achilles</label>
                                      </li>
                                      <li>
                                        <input type="radio" name="filters-hero" id="FiltersAgamemnon" /> <label for="FiltersAgamemnon">Agamemnon</label>
                                      </li>
                                    </ul>
                                  </li>
                                  <li class="push-half--bottom">
                                    <label for="filters-countries">Select your country</label>
                                    <select id="filters-countries" name="filters-countries" class="width--100">
                                      <option>Argentina</option>
                                      <option>Albania</option>
                                      <option selected="selected">Aruba</option>
                                    </select>
                                  </li>
                                  <li class="push-half--bottom">
                                    <label>What is your feedback?</label>
                                    <textarea class="text-input width--100" name="comments" >Please enter your comments...</textarea>
                                  </li>
                                  <li class="push-half--bottom">
                                    <label>How would you like to be contacted?</label>
                                    <ul class="check-list">
                                      <li>
                                        <input type="checkbox" id="by-email"/> <label for="by-email">By email</label>
                                      </li>
                                      <li>
                                        <input type="checkbox" id="by-post"/> <label for="by-post">By post</label>
                                      </li>
                                      <li>
                                        <input type="checkbox" id="by-pigeon"/> <label for="by-pigeon">By carrier pigeon</label>
                                      </li>
                                    </ul>
                                  </li>
                                  <li class="push-half--bottom">
                                    <label for="countries">Select your country</label>
                                    <select id="countries" name="countries" class="width--100">
                                      <option>Argentina</option>
                                      <option>Albania</option>
                                      <option selected="selected">Aruba</option>
                                    </select>
                                  </li>
                                </ul>
                              </form>
                            </div>
                          </div>
                          <div class="filter__sidebar--open">
                            <i class="fa fa-chevron-right"></i>
                          </div>

                          <div class="filter__sidebar--seperator"></div>

                          <div class="filter__sidebar--action soft-half">
                            <button class="btn js-filter-panel__action width--100" id="filter-ex-d-sidebar-action" disabled>Apply</button>
                          </div>
                        </div>
                        <div class="filter__content" id="filter-ex-d-content">
                          <div class="well well--border-color push">
                            <h3 class="flush">Results Content</h3>
                            <button class="btn filter__content--action js-filter-panel__remote-open push--top" id="filter-ex-d-content-action">
                                <i class="filter__content--state js-filter-panel__state fa icon-cme-filter"></i>
                                <span class="push-quarter--left">Filters</span>
                            </button>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">1</h3>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">2</h3>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">3</h3>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">4</h3>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">5</h3>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">6</h3>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">7</h3>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">8</h3>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">9</h3>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">10</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <script type="text/javascript" src="js/commonUI.js"></script>
                  <script>
                    function init() {
                      commonUI.initializeFilter();
                      var filter = document.querySelector('.js-filter-panel');
                      filter.addEventListener('apply.commonui.filter', function (event) {}, false);
                    }
                    window.onload = init;
                  </script>
                </body>
              </html>
            `}>
          </iframe>
        </div>

        <br/>

        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button>

        <br/><br/>

        <pre className="hide-code"><code className="language-html">{`<div class="filter__group">
  <nav class="nav nav--global nav--light drop-shadow js-nav">
    <div class="nav__inner">
      <div class="nav__header nav__header--logo-only">
        <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
      </div>
      <ul class="nav__items--primary">
        <li class="nav__item--primary"><a>Trading</a></li>
        <li class="nav__item--primary"><a>Clearing</a></li>
        <li class="nav__item--primary"><a>Regulation</a></li>
        <li class="nav__item--primary"><a>Data</a></li>
        <li class="nav__item--primary"><a>Education</a></li>
        <li class="nav__item--primary"><a>About</a></li>
      </ul>
      <ul class="nav__actions">
        <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-star-o nav__action-icon"></i></button></li>
        <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-search nav__action-icon"></i></button></li>
        <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-profile nav__action-icon"></i></button></li>
      </ul>
    </div>
  </nav>
  <div class="filter js-filter-panel is-icon">
    <div class="filter__wrapper">
      <div class="filter__sidebar js-filter-panel__open">
        <div class="filter__sidebar--heading">
          <div class="filter__sidebar--heading--icon">
            <i class="icon-cme-filter"></i>
          </div>
          <button class="btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard">
            <span class="filter__sidebar--heading--hide--icon">
              <i class="fa fa-chevron-left"></i> Hide
            </span>
            <span class="filter__sidebar--heading--hide--close">
              <i class="icon-cme-close-circle-o"></i>
            </span>
          </button>
        </div>
        <div class="filter__sidebar--content">
          <div class="filter__sidebar--content--wrapper">
            <form>
              <ul class="form-fields">
                <li class="push-half--bottom">
                  <label for="filtersFirstName">First Name</label>
                  <input id="filtersFirstName" type="text" class="text-input width--100"/>
                </li>
                <li class="push-half--bottom">
                  <label for="filtersSecondName">Second Name</label>
                  <input id="filtersSecondName" type="text" class="text-input width--100"/>
                </li>
                <li class="push-half--bottom">
                  <label for="filtersAge">Age</label>
                  <input id="filtersAge" type="text" class="text-input width--100"/>
                </li>
                <li class="push-half--bottom">
                  <label>How would you like to be contacted?</label>
                  <ul class="check-list">
                    <li>
                        <input type="checkbox" id="filters-by-email"/> <label for="filters-by-email">By email</label>
                    </li>
                    <li>
                        <input type="checkbox" id="filters-by-post"/> <label for="filters-by-post">By post</label>
                    </li>
                    <li>
                        <input type="checkbox" id="filters-by-pigeon"/> <label for="filters-by-pigeon">By carrier pigeon</label>
                    </li>
                  </ul>
                </li>
                <li class="push-half--bottom">
                  <label>Select your hero</label>
                  <ul class="check-list">
                    <li>
                      <input type="radio" name="filters-hero" id="FiltersHector" /> <label for="FiltersHector">Hector</label>
                    </li>
                    <li>
                      <input type="radio" name="filters-hero" id="FiltersAchilles" /> <label for="FiltersAchilles">Achilles</label>
                    </li>
                    <li>
                      <input type="radio" name="filters-hero" id="FiltersAgamemnon" /> <label for="FiltersAgamemnon">Agamemnon</label>
                    </li>
                  </ul>
                </li>
                <li class="push-half--bottom">
                  <label for="filters-countries">Select your country</label>
                  <select id="filters-countries" name="filters-countries" class="width--100">
                    <option>Argentina</option>
                    <option>Albania</option>
                    <option selected="selected">Aruba</option>
                  </select>
                </li>
                <li class="push-half--bottom">
                  <label>What is your feedback?</label>
                  <textarea class="text-input width--100" name="comments" >Please enter your comments...</textarea>
                </li>
                <li class="push-half--bottom">
                  <label>How would you like to be contacted?</label>
                  <ul class="check-list">
                    <li>
                      <input type="checkbox" id="by-email"/> <label for="by-email">By email</label>
                    </li>
                    <li>
                      <input type="checkbox" id="by-post"/> <label for="by-post">By post</label>
                    </li>
                    <li>
                      <input type="checkbox" id="by-pigeon"/> <label for="by-pigeon">By carrier pigeon</label>
                    </li>
                  </ul>
                </li>
                <li class="push-half--bottom">
                  <label for="countries">Select your country</label>
                  <select id="countries" name="countries" class="width--100">
                    <option>Argentina</option>
                    <option>Albania</option>
                    <option selected="selected">Aruba</option>
                  </select>
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div class="filter__sidebar--open">
          <i class="fa fa-chevron-right"></i>
        </div>

        <div class="filter__sidebar--seperator"></div>

        <div class="filter__sidebar--action soft-half">
          <button class="btn js-filter-panel__action width--100" disabled>Apply</button>
        </div>
      </div>
      <div class="filter__content">
        <div class="well well--border-color push">
          <h3 class="flush">Results Content</h3>
          <button class="btn filter__content--action js-filter-panel__remote-open push--top">
              <i class="filter__content--state js-filter-panel__state fa icon-cme-filter"></i>
              <span class="push-quarter--left">Filters</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>`}</code></pre>

        <br/><hr/><br/>

        <h3>Filter Categories</h3>

        <p>Using the Accordian component we can sub-divide filters into categories. This requires the Common UI Accordion JavaScript to be initialised like
        this: <code>commonUI.initializeAccordion();</code>. It is recommended to use an accordion when there is more than one item per category. Here is an example:</p>

        <div className="iframe-container display--flex" style={{
          "height":"700px",
          "border": "0",
          "flexDirection": "column"
        }}>
          <iframe seamless srcDoc={`
            <html class="height--100" style="background-color: #dedfe0">
              <head>
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
                <link rel="stylesheet" type="text/css" href="css/commonUI.css">
              </head>
                <body class="height--100">
                  <div class="filter__group">
                    <nav class="nav nav--global nav--light drop-shadow js-nav">
                      <div class="nav__inner">
                        <div class="nav__header nav__header--logo-only">
                          <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
                        </div>
                        <ul class="nav__items--primary">
                          <li class="nav__item--primary"><a>Trading</a></li>
                          <li class="nav__item--primary"><a>Clearing</a></li>
                          <li class="nav__item--primary"><a>Regulation</a></li>
                          <li class="nav__item--primary"><a>Data</a></li>
                          <li class="nav__item--primary"><a>Education</a></li>
                          <li class="nav__item--primary"><a>About</a></li>
                        </ul>
                        <ul class="nav__actions">
                          <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-star-o nav__action-icon"></i></button></li>
                          <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-search nav__action-icon"></i></button></li>
                          <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-profile nav__action-icon"></i></button></li>
                        </ul>
                      </div>
                    </nav>
                    <div class="filter js-filter-panel is-icon" id="filter-ex-d">
                      <div class="filter__wrapper">
                        <div class="filter__sidebar js-filter-panel__open" id="filter-ex-d-sidebar">
                          <div class="filter__sidebar--heading">
                            <div class="filter__sidebar--heading--icon">
                              <i class="icon-cme-filter"></i>
                            </div>
                            <button class="btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard" id="filter-ex-d-sidebar-hide">
                              <span class="filter__sidebar--heading--hide--icon">
                                <i class="fa fa-chevron-left"></i> Hide
                              </span>
                              <span class="filter__sidebar--heading--hide--close">
                                <i class="icon-cme-close-circle-o"></i>
                              </span>
                            </button>
                          </div>
                          <div class="filter__sidebar--content hard" id="filter-ex-d-sidebar-content">
                            <div class="filter__sidebar--content--wrapper">
                              <form class="js-filter-content-form">
                                <div class="accordion js-accordion">
                                  <div class="accordion__item">
                                      <div class="accordion__title">
                                          <h5 class="flush">Category 1</h5>
                                      </div>
                                      <div class="accordion__content">
                                        <ul class="form-fields">
                                          <li class="push-half--bottom">
                                            <label for="filtersFirstName">First Name</label>
                                            <input id="filtersFirstName" type="text" class="text-input width--100"/>
                                          </li>
                                          <li class="push-half--bottom">
                                            <label for="filtersSecondName">Second Name</label>
                                            <input id="filtersSecondName" type="text" class="text-input width--100"/>
                                          </li>
                                          <li class="push-half--bottom">
                                            <label for="filtersAge">Age</label>
                                            <input id="filtersAge" type="text" class="text-input width--100"/>
                                          </li>
                                        </ul>
                                      </div>
                                  </div>
                                  <div class="accordion__item">
                                    <div class="accordion__title">
                                      <h5 class="flush">Category 2</h5>
                                    </div>
                                    <div class="accordion__content">
                                      <ul class="form-fields">
                                        <li class="push-half--bottom">
                                          <label>How would you like to be contacted?</label>
                                          <ul class="check-list">
                                            <li>
                                                <input type="checkbox" id="filters-by-email"/> <label for="filters-by-email">By email</label>
                                            </li>
                                            <li>
                                                <input type="checkbox" id="filters-by-post"/> <label for="filters-by-post">By post</label>
                                            </li>
                                            <li>
                                                <input type="checkbox" id="filters-by-pigeon"/> <label for="filters-by-pigeon">By carrier pigeon</label>
                                            </li>
                                          </ul>
                                        </li>
                                        <li class="push-half--bottom">
                                          <label>Select your hero</label>
                                          <ul class="check-list">
                                            <li>
                                              <input type="radio" name="filters-hero" id="FiltersHector" /> <label for="FiltersHector">Hector</label>
                                            </li>
                                            <li>
                                              <input type="radio" name="filters-hero" id="FiltersAchilles" /> <label for="FiltersAchilles">Achilles</label>
                                            </li>
                                            <li>
                                              <input type="radio" name="filters-hero" id="FiltersAgamemnon" /> <label for="FiltersAgamemnon">Agamemnon</label>
                                            </li>
                                          </ul>
                                        </li>
                                      </ul>
                                    </div>
                                </div>
                                <div class="accordion__item">
                                    <div class="accordion__title">
                                      <h5 class="flush">Category 3</h5>
                                    </div>
                                    <div class="accordion__content">
                                      <ul class="form-fields">
                                        <li class="push-half--bottom">
                                          <label for="filters-countries">Select your country</label>
                                          <select id="filters-countries" name="filters-countries" class="width--100">
                                            <option>Argentina</option>
                                            <option>Albania</option>
                                            <option selected="selected">Aruba</option>
                                          </select>
                                        </li>
                                        <li class="push-half--bottom">
                                          <label>What is your feedback?</label>
                                          <textarea class="text-input width--100" name="comments" >Please enter your comments...</textarea>
                                        </li>
                                        <li class="push-half--bottom">
                                          <label>How would you like to be contacted?</label>
                                          <ul class="check-list">
                                            <li>
                                              <input type="checkbox" id="by-email"/> <label for="by-email">By email</label>
                                            </li>
                                            <li>
                                              <input type="checkbox" id="by-post"/> <label for="by-post">By post</label>
                                            </li>
                                            <li>
                                              <input type="checkbox" id="by-pigeon"/> <label for="by-pigeon">By carrier pigeon</label>
                                            </li>
                                          </ul>
                                        </li>
                                        <li class="push-half--bottom">
                                          <label for="countries">Select your country</label>
                                          <select id="countries" name="countries" class="width--100">
                                            <option>Argentina</option>
                                            <option>Albania</option>
                                            <option selected="selected">Aruba</option>
                                          </select>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                          <div class="filter__sidebar--open">
                            <i class="fa fa-chevron-right"></i>
                          </div>

                          <div class="filter__sidebar--seperator"></div>

                          <div class="filter__sidebar--action soft-half">
                            <button class="btn js-filter-panel__action width--100" id="filter-ex-d-sidebar-action" disabled>Apply</button>
                          </div>
                        </div>
                        <div class="filter__content" id="filter-ex-d-content">
                          <div class="well well--border-color push">
                            <h3 class="flush">Results Content</h3>
                            <button class="btn filter__content--action js-filter-panel__remote-open push--top" id="filter-ex-d-content-action">
                                <i class="filter__content--state js-filter-panel__state fa icon-cme-filter"></i>
                                <span class="push-quarter--left">Filters</span>
                            </button>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">1</h3>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">2</h3>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">3</h3>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">4</h3>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">5</h3>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">6</h3>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">7</h3>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">8</h3>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">9</h3>
                          </div>
                          <div class="well well--border-color push">
                            <h3 class="flush">10</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <script type="text/javascript" src="js/commonUI.js"></script>
                  <script>
                    function init() {
                      commonUI.initializeFilter();
                      commonUI.initializeAccordion();
                      var filter = document.querySelector('.js-filter-panel');
                      filter.addEventListener('apply.commonui.filter', function (event) {}, false);
                    }
                    window.onload = init;
                  </script>
                </body>
              </html>
            `}>
          </iframe>
        </div>

        <br/>

        <button type="button" className="btn btn--secondary show-code"><i className="fa fa-plus"></i>View source</button>

        <br/><br/>

        <pre className="hide-code"><code className="language-html">{`<div class="filter__group">
  <nav class="nav nav--global nav--light drop-shadow js-nav">
    <div class="nav__inner">
      <div class="nav__header nav__header--logo-only">
        <a class="nav__logo" href="//www.cmegroup.com" title="CME Group" target="_blank"></a>
      </div>
      <ul class="nav__items--primary">
        <li class="nav__item--primary"><a>Trading</a></li>
        <li class="nav__item--primary"><a>Clearing</a></li>
        <li class="nav__item--primary"><a>Regulation</a></li>
        <li class="nav__item--primary"><a>Data</a></li>
        <li class="nav__item--primary"><a>Education</a></li>
        <li class="nav__item--primary"><a>About</a></li>
      </ul>
      <ul class="nav__actions">
        <li class="nav__action"><button class="nav__action-btn"><i class="fa fa-star-o nav__action-icon"></i></button></li>
        <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-search nav__action-icon"></i></button></li>
        <li class="nav__action"><button class="nav__action-btn"><i class="icon-cme-profile nav__action-icon"></i></button></li>
      </ul>
    </div>
  </nav>
  <div class="filter js-filter-panel is-icon" id="filter-ex-d">
    <div class="filter__wrapper">
      <div class="filter__sidebar js-filter-panel__open" id="filter-ex-d-sidebar">
        <div class="filter__sidebar--heading">
          <div class="filter__sidebar--heading--icon">
            <i class="icon-cme-filter"></i>
          </div>
          <button class="btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard" id="filter-ex-d-sidebar-hide">
            <span class="filter__sidebar--heading--hide--icon">
              <i class="fa fa-chevron-left"></i> Hide
            </span>
            <span class="filter__sidebar--heading--hide--close">
              <i class="icon-cme-close-circle-o"></i>
            </span>
          </button>
        </div>
        <div class="filter__sidebar--content hard" id="filter-ex-d-sidebar-content">
          <div class="filter__sidebar--content--wrapper">
            <form class="js-filter-content-form">
              <div class="accordion js-accordion">
                <div class="accordion__item">
                  <div class="accordion__title">
                      <h5 class="flush">Category 1</h5>
                  </div>
                  <div class="accordion__content">
                    <ul class="form-fields">
                      <li class="push-half--bottom">
                        <label for="filtersFirstName">First Name</label>
                        <input id="filtersFirstName" type="text" class="text-input width--100"/>
                      </li>
                      <li class="push-half--bottom">
                        <label for="filtersSecondName">Second Name</label>
                        <input id="filtersSecondName" type="text" class="text-input width--100"/>
                      </li>
                      <li class="push-half--bottom">
                        <label for="filtersAge">Age</label>
                        <input id="filtersAge" type="text" class="text-input width--100"/>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="accordion__item">
                  <div class="accordion__title">
                    <h5 class="flush">Category 2</h5>
                  </div>
                  <div class="accordion__content">
                    <ul class="form-fields">
                      <li class="push-half--bottom">
                        <label>How would you like to be contacted?</label>
                        <ul class="check-list">
                          <li>
                              <input type="checkbox" id="filters-by-email"/> <label for="filters-by-email">By email</label>
                          </li>
                          <li>
                              <input type="checkbox" id="filters-by-post"/> <label for="filters-by-post">By post</label>
                          </li>
                          <li>
                              <input type="checkbox" id="filters-by-pigeon"/> <label for="filters-by-pigeon">By carrier pigeon</label>
                          </li>
                        </ul>
                      </li>
                      <li class="push-half--bottom">
                        <label>Select your hero</label>
                        <ul class="check-list">
                          <li>
                            <input type="radio" name="filters-hero" id="FiltersHector" /> <label for="FiltersHector">Hector</label>
                          </li>
                          <li>
                            <input type="radio" name="filters-hero" id="FiltersAchilles" /> <label for="FiltersAchilles">Achilles</label>
                          </li>
                          <li>
                            <input type="radio" name="filters-hero" id="FiltersAgamemnon" /> <label for="FiltersAgamemnon">Agamemnon</label>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="accordion__item">
                  <div class="accordion__title">
                    <h5 class="flush">Category 3</h5>
                  </div>
                  <div class="accordion__content">
                    <ul class="form-fields">
                      <li class="push-half--bottom">
                        <label for="filters-countries">Select your country</label>
                        <select id="filters-countries" name="filters-countries" class="width--100">
                          <option>Argentina</option>
                          <option>Albania</option>
                          <option selected="selected">Aruba</option>
                        </select>
                      </li>
                      <li class="push-half--bottom">
                        <label>What is your feedback?</label>
                        <textarea class="text-input width--100" name="comments" >Please enter your comments...</textarea>
                      </li>
                      <li class="push-half--bottom">
                        <label>How would you like to be contacted?</label>
                        <ul class="check-list">
                          <li>
                            <input type="checkbox" id="by-email"/> <label for="by-email">By email</label>
                          </li>
                          <li>
                            <input type="checkbox" id="by-post"/> <label for="by-post">By post</label>
                          </li>
                          <li>
                            <input type="checkbox" id="by-pigeon"/> <label for="by-pigeon">By carrier pigeon</label>
                          </li>
                        </ul>
                      </li>
                      <li class="push-half--bottom">
                        <label for="countries">Select your country</label>
                        <select id="countries" name="countries" class="width--100">
                          <option>Argentina</option>
                          <option>Albania</option>
                          <option selected="selected">Aruba</option>
                        </select>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="filter__sidebar--open">
          <i class="fa fa-chevron-right"></i>
        </div>

        <div class="filter__sidebar--seperator"></div>

        <div class="filter__sidebar--action soft-half">
          <button class="btn js-filter-panel__action width--100" id="filter-ex-d-sidebar-action" disabled>Apply</button>
        </div>
      </div>
      <div class="filter__content" id="filter-ex-d-content">
        <div class="well well--border-color push">
          <h3 class="flush">Results Content</h3>
          <button class="btn filter__content--action js-filter-panel__remote-open push--top" id="filter-ex-d-content-action">
              <i class="filter__content--state js-filter-panel__state fa icon-cme-filter"></i>
              <span class="push-quarter--left">Filters</span>
          </button>
        </div>
        <div class="well well--border-color push">
          <h3 class="flush">1</h3>
        </div>
        <div class="well well--border-color push">
          <h3 class="flush">2</h3>
        </div>
        <div class="well well--border-color push">
          <h3 class="flush">3</h3>
        </div>
        <div class="well well--border-color push">
          <h3 class="flush">4</h3>
        </div>
        <div class="well well--border-color push">
          <h3 class="flush">5</h3>
        </div>
        <div class="well well--border-color push">
          <h3 class="flush">6</h3>
        </div>
        <div class="well well--border-color push">
          <h3 class="flush">7</h3>
        </div>
        <div class="well well--border-color push">
          <h3 class="flush">8</h3>
        </div>
        <div class="well well--border-color push">
          <h3 class="flush">9</h3>
        </div>
        <div class="well well--border-color push">
          <h3 class="flush">10</h3>
        </div>
      </div>
    </div>
  </div>
</div>`}</code></pre>

        <br/><hr/><br/>

        <h3>Responsive Behaviour</h3>
        <p>On the Mobile view the Filter becomes it's own page, full width. 'Hide' text becomes 'X' (cme close icon) Filters are triggered by a button on the main results page, recommend icon & text on the button. Filters icon becomes a tick mark on this button when filters have been applied.</p>

        <br/>

        <h3>Hide/Show</h3>
        <p>This feature is best used when the sidebar does not always need to be visible and to give the data table more breathing room. Not necessary for smaller filters / data light tables. By default, the sidebar should be visible for discoverability.</p>

        <p>To close filter: Use chevron & 'Hide' link in Filter Header. To open: icon & a single centered blue chevron to open. The full closed sidebar is clickable to open.</p>

        <select className="size-select">
          <option value="1199">Select a resolution</option>
          <option value="479">480px (xs)</option>
          <option value="767">768px (sm)</option>
          <option value="991">992px (md)</option>
          <option value="1199">1200px (lg)</option>
        </select>

        <br/><br/>

        <div className="iframe-container" style={{"height":"700px", "border": "0"}}>
          <iframe seamless srcDoc={`
            <html class="height--100" style="background-color: #dedfe0">
              <head>
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/all.css">
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.5.0/css/v4-shims.css"> 
                <link rel="stylesheet" type="text/css" href="css/commonUI.css">
              </head>
                <body class="height--100">
                  <div class="filter js-filter-panel is-icon">
                    <div class="filter__wrapper">
                      <div class="filter__sidebar js-filter-panel__open">
                        <div class="filter__sidebar--heading">
                          <div class="filter__sidebar--heading--icon">
                            <i class="icon-cme-filter"></i>
                          </div>
                          <button class="btn btn--transparent filter__sidebar--heading--hide js-filter-panel__close text--right hard">
                            <span class="filter__sidebar--heading--hide--icon">
                              <i class="fa fa-chevron-left"></i> Hide
                            </span>
                            <span class="filter__sidebar--heading--hide--close">
                              <i class="icon-cme-close-circle-o"></i>
                            </span>
                          </button>
                        </div>
                        <div class="filter__sidebar--content">
                          <div class="filter__sidebar--content--wrapper">
                            <form>
                              <ul class="form-fields">
                                <li class="push-half--bottom">
                                  <label for="firstName">First Name</label>
                                  <input id="firstName" type="text" class="text-input width--100"/>
                                </li>
                                <li class="push-half--bottom">
                                  <label for="secondName">Second Name</label>
                                  <input id="secondName" type="text" class="text-input width--100"/>
                                </li>
                                <li class="push-half--bottom">
                                  <label for="age">Age</label>
                                  <input id="age" type="text" class="text-input width--100"/>
                                </li>
                                <li class="push-half--bottom">
                                  <label>How would you like to be contacted?</label>
                                  <ul class="check-list">
                                      <li>
                                          <input type="checkbox" id="by-email"/> <label for="by-email">By email</label>
                                      </li>
                                      <li>
                                          <input type="checkbox" id="by-post"/> <label for="by-post">By post</label>
                                      </li>
                                      <li>
                                          <input type="checkbox" id="by-pigeon"/> <label for="by-pigeon">By carrier pigeon</label>
                                      </li>
                                  </ul>
                                </li>
                                <li class="push-half--bottom">
                                    <label>Select your hero</label>
                                    <ul class="check-list">
                                        <li>
                                            <input type="radio" name="hero" id="Hector" /> <label for="Hector">Hector</label>
                                        </li>
                                        <li>
                                            <input type="radio" name="hero" id="Achilles" /> <label for="Achilles">Achilles</label>
                                        </li>
                                        <li>
                                          <input type="radio" name="hero" id="Agamemnon" /> <label for="Agamemnon">Agamemnon</label>
                                        </li>
                                    </ul>
                                  </li>
                                <li class="push-half--bottom">
                                    <label for="countries">Select your country</label>
                                    <select id="countries" name="countries" class="width--100">
                                         <option>Argentina</option>
                                         <option>Albania</option>
                                         <option selected="selected">Aruba</option>
                                      </select>
                                  </li>
                                <li class="push-half--bottom">
                                    <label>What is your feedback?</label>
                                    <textarea class="text-input width--100" name="comments" >Please enter your comments...</textarea>
                                  </li>
                                <li class="push-half--bottom">
                                    <label>How would you like to be contacted?</label>
                                    <ul class="check-list">
                                        <li>
                                            <input type="checkbox" id="by-email"/> <label for="by-email">By email</label>
                                        </li>
                                        <li>
                                            <input type="checkbox" id="by-post"/> <label for="by-post">By post</label>
                                        </li>
                                        <li>
                                            <input type="checkbox" id="by-pigeon"/> <label for="by-pigeon">By carrier pigeon</label>
                                        </li>
                                    </ul>
                                  </li>
                                <li class="push-half--bottom">
                                    <label for="countries">Select your country</label>
                                    <select id="countries" name="countries" class="width--100">
                                         <option>Argentina</option>
                                         <option>Albania</option>
                                         <option selected="selected">Aruba</option>
                                      </select>
                                  </li>
                              </ul>
                            </form>
                          </div>
                        </div>
                        <div class="filter__sidebar--open">
                          <i class="fa fa-chevron-right"></i>
                        </div>

                        <div class="filter__sidebar--action soft-half">
                          <button class="btn js-filter-panel__action width--100" disabled>Apply</button>
                        </div>
                      </div>
                      <div class="filter__content">
                        <div class="well well--border-color push">
                          <h3 class="flush">Results Content</h3>
                          <button class="btn filter__content--action js-filter-panel__remote-open push--top">
                              <i class="filter__content--state js-filter-panel__state fa icon-cme-filter"></i>
                              <span class="push-quarter--left">Filters</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <script type="text/javascript" src="js/commonUI.js"></script>
                  <script>
                    function init() {
                      commonUI.initializeFilter();
                    }
                    window.onload = init;
                  </script>
                </body>
              </html>
            `}>
          </iframe>
        </div>

        <br/>

        <p>This is a javascript enabled component. To enable the close and open functionality of the filter drawer you must initialize it using the following snippet:</p>

        <pre><code className="language-javascript">{`commonUI.initializeFilter();`}</code></pre>

        <br />

        <p>If you are embedding the Common UI filter within your application and it is being wrapped by one or many divs, you may need to apply the <code>.height--inherit</code> helper to these parent divs for the height be calculated correctly. Common UI provides 100% height to the <code>html</code> and <code>body</code> tags by default.</p>

        <br/>

        <br/><hr/><br/>

      </section>
    )
  }
}

export default Filters



// WEBPACK FOOTER //
// ./styleguide/components/sections/Filters.js